var map = {
	"./1.jpg": "PEkz",
	"./2.jpg": "2XPM",
	"./3.jpg": "xthu",
	"./4.jpg": "UXgR",
	"./5.jpg": "m7bB",
	"./empty.jpg": "ZvAE"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Ivkr";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/feedbacks ^\.\/.*$
// module id = Ivkr
// module chunks = 0